/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { Collapse, Typography } from 'antd'
import { useTranslation } from 'react-i18next' // Import useTranslation

const { Panel } = Collapse
const { Link, Text } = Typography

// Define a function that generates faqData using the t function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFaqData = (t:any) => [
  {
    key: '0',
    header: t('faq.item0.header'),
    content: (
      <>
        <ol>
          <li>{t('faq.item0.contentLi1')}</li>
          <li>{t('faq.item0.contentLi2')}</li>
          <li>{t('faq.item0.contentLi3')}</li>
          <li>{t('faq.item0.contentLi4')}</li>
          <li>{t('faq.item0.contentLi5')}</li>
          <li>
            <Text strong>{t('faq.item0.contentLi6Strong')}</Text> {t('faq.item0.contentLi6Text')}
          </li>
          <li>{t('faq.item0.contentLi7')}</li>
        </ol>
        <Text>
          {t('faq.item0.contentP1Text1')}{' '}
          <Link href="https://www.amazon.com/gp/pdp/profile" target="_blank" rel="noopener noreferrer">
            {t('faq.item0.contentP1LinkText')}
          </Link>
          {t('faq.item0.contentP1Text2')}
        </Text>
      </>
    )
  },
  {
    key: '1',
    header: t('faq.item1.header'),
    content: t('faq.item1.content'),
  },
  {
    key: '2',
    header: t('faq.item2.header'),
    content: t('faq.item2.content'),
  },
  {
    key: '3',
    header: t('faq.item3.header'),
    content: t('faq.item3.content'),
  },
  {
    key: '4',
    header: t('faq.item4.header'),
    content: (
      <>
        {t('faq.item4.contentP1Text1')}{' '}
        <Link href="https://www.amazon.com/gp/pdp/profile" target="_blank" rel="noopener noreferrer">
          {t('faq.item4.contentP1LinkText')}
        </Link>
        {t('faq.item4.contentP1Text2')}
      </>
    )
  },
  {
    key: '5',
    header: t('faq.item5.header'),
    content: t('faq.item5.content'),
  },
  {
    key: '6',
    header: t('faq.item6.header'),
    content: t('faq.item6.content'),
  },
  {
    key: '7',
    header: t('faq.item7.header'),
    content: t('faq.item7.content'),
  },
  {
    key: '8',
    header: t('faq.item8.header'),
    content: t('faq.item8.content'),
  },
  {
    key: '9',
    header: t('faq.item9.header'),
    content: t('faq.item9.content'),
  },
  {
    key: '10',
    header: t('faq.item10.header'),
    content: t('faq.item10.content'),
  }
]

function Faq() {
  const { t } = useTranslation('landing') // Use the 'landing' namespace
  const faqData = getFaqData(t) // Generate faqData with the t function

  return (
    <Collapse accordion>
      {faqData.map(item => (
        <Panel header={item.header} key={item.key}>
          {typeof item.content === 'string' ? <p>{item.content}</p> : item.content}
        </Panel>
      ))}
    </Collapse>
  )
}

export default Faq